<script>
  import InfoCard from './info-card.svelte';

  //colors: Primary(#4e73df),Success(#1cc88a),Info(#36b9cc),Warning(#f6c23e),Danger(#e74a3b),Secondary(#858796),Light(#f8f9fc),Dark(#5a5c69)
  export let color = 'primary';
  export let title;
  export let ico;
  export let value;

  const numberFormat = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
</script>

<InfoCard color="{color}" title="{title}" ico="{ico}">
    <div class="h5 mb-0 font-weight-bold text-gray-800">
        {numberFormat.format(value)}
    </div>
</InfoCard>
